export default "__VITE_ASSET__ByncHEBQ__"